import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../../../context/app';
import useIsMobile from '../../../hooks/useIsMobile';
import { useNavStartingPlaceLabel } from '../../../hooks/useNavStartingPlaceLabel';
import Datalist from '../datalist/Datalist';
import styles from './navigationDetailsCard.module.scss';

type NavigationDetailsCardProps = {
  title?: string;
};

const NavigationDetailsCard: React.FC<NavigationDetailsCardProps> = ({
  title,
}) => {
  const { t } = useTranslation('common');
  const { navDestinationPlace } = useContext(AppContext);
  const navStartingPlaceLabel = useNavStartingPlaceLabel();
  const isMobile = useIsMobile();

  return (
    <div
      className={`${
        !isMobile ? styles.navigationDetails : styles.navigationDetailsMobile
      }`}
    >
      {title && <h2 className={styles.title}>{title}</h2>}
      <Datalist
        title={t('campusNavigation.share.navigation.from')}
        description={navStartingPlaceLabel}
      />
      <Datalist
        title={t('campusNavigation.share.navigation.to')}
        description={navDestinationPlace?.name || ''}
      />
    </div>
  );
};

export default NavigationDetailsCard;
